"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const TwoWayToggle = (_a) => {
    var { name, off, on, onChange, value } = _a, rest = __rest(_a, ["name", "off", "on", "onChange", "value"]);
    function handleChange(e) {
        onChange(e.target.checked);
    }
    return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
        react_1.default.createElement("span", { style: { marginRight: '12px' } }, off(value)),
        react_1.default.createElement("div", { className: 'form-check form-switch' },
            react_1.default.createElement("input", Object.assign({ checked: value, className: 'form-check-input', name: name, onChange: handleChange, type: 'checkbox' }, rest))),
        react_1.default.createElement("span", null, on(value))));
};
exports.default = TwoWayToggle;
